import { z } from "zod/v3";

export const AgentChoiceOptionSchema = z.object({
  id: z.string(),
  label: z.string(),
  description: z.string().nullable(),
  payload: z.record(z.unknown()).nullable(),
});

export type AgentChoiceOptionDTO = z.infer<typeof AgentChoiceOptionSchema>;

export const AgentChoiceSchema = z.object({
  id: z.string(),
  question: z.string(),
  options: z.array(AgentChoiceOptionSchema),
  status: z.enum(["PENDING", "RESOLVED", "SUPERSEDED", "EXPIRED"]),
  selectedOptionId: z.string().nullable(),
  expiresAt: z.coerce.date().nullable(),
});

export type AgentChoiceDTO = z.infer<typeof AgentChoiceSchema>;
